import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = {
  isLoading: false,
  apiError: null,
};

const fetchDeactivateReducer = state => ({
  ...state,
  isLoading: true,
  apiError: null,
});

const deactivateSuccessReducer = state => ({
  ...state,
  isLoading: false,
});

const deactivateFailureReducer = (state, { payload }) => ({
  ...state,
  isLoading: false,
  apiError: payload.message,
});

export default createReducer(initialState, {
  [actionTypes.DEACTIVATE_LOCKER_REQUEST]: fetchDeactivateReducer,
  [actionTypes.DEACTIVATE_LOCKER_SUCCESS]: deactivateSuccessReducer,
  [actionTypes.DEACTIVATE_LOCKER_FAILURE]: deactivateFailureReducer,
});
